import RecommendedArtists from '../components/cards/aside/recommended-artists';
import EmptyCard from '../components/cards/empty.card';
import Container from '../components/containers/container';
import Header from '../components/header/default.header';
import { VStack } from '../components/layouts/stack.layout';
import MainLayout from '../components/layouts/v2/main.layout';
import AlternativeNavigation from '../components/navigation/alternative.navigation';
import IconTab from '../components/navigation/icon-tab';
import Search from '../components/overlay/search';
import { IconType } from '../types/icon.type';

export default function Notifications() {
  const notifications = [];

  const state = ['notifications', 'mentions'];
  const icons: IconType[] = ['notifications', 'mention'];

  return (
    <MainLayout title="Notifications">
      <MainLayout.Header>
        <Header />
      </MainLayout.Header>
      <MainLayout.Content>
        <MainLayout.Navigation>
          <AlternativeNavigation />
        </MainLayout.Navigation>
        <MainLayout.Main className="relative">
          <IconTab
            className="top-0 mobile:px-2 tablet-lg:px-[40px] border-l border-dark-gray"
            icons={icons}
            state={state}
          >
            <IconTab.Content>
              <Container extensions="relative">
                {!notifications.length && <EmptyCard variant="notifications" />}
              </Container>
            </IconTab.Content>
            <IconTab.Content>
              <Container extensions="relative">
                {!notifications.length && <EmptyCard variant="notifications" />}
              </Container>
            </IconTab.Content>
          </IconTab>
        </MainLayout.Main>
      </MainLayout.Content>
      <MainLayout.Aside>
        <VStack gap="md">
          <Container extensions="w-full pb-2 tablet-lg:px-[50px]">
            <Search />
          </Container>
          <RecommendedArtists />
        </VStack>
      </MainLayout.Aside>
    </MainLayout>
  );
}
